// BFF: ○ external — the Zus Aggregated Profile is fetched from Zus, not from api/.
export { default } from './ZusAggregatedProfile'
